import { SaveQueryInputDto } from './save-query-input.dto';

export class QueryMatchingConversationsRequestDto {
  skipCount: number;
  maxResultCount: number;
  queryInput: SaveQueryInputDto;
}
